export const events = {
  searchFilter: 'filter_click',
  searchSort: 'sort_click',
  searchLabel: 'filter_label_click',
  searchResult: 'search',
  locationSearch: 'community_search',
  navigation: 'navigation',
  homepageContentButton: 'content_button',
  careQuestionareStart: 'care_questionnare_start',
  careQuestionnareStep: 'care_questionnare_step_',
  careQuestionnareComplete: 'care_questionnare_complete',
  formStart: 'form_start',
  formSubmit: 'form_submit',
  carousel: 'carousel',
  ctaCard: 'cta_card',
  ctaLink: 'cta_link',
  ctaButton: 'cta_button',
  quickAccess: 'quick_access',
  faq: 'faq_click',
  faqQuestion: 'faq_question_click',
  video: 'video'
};

export const selectors = {
  // Search
  searchFilter: '.resource-listing-row__dynamic-facets-container .coveo-checkbox, .search-list-row__dynamic-facets-container .coveo-checkbox',
  searchFilterContainer: '.resource-listing-row__dynamic-facet, .search-list-row__dynamic-facet',
  searchFilterTitle: '.coveo-dynamic-facet-header-title',
  searchSort: '.search-list-row__coveo-sort-dropdown .coveo-dropdown, .resource-listing-row__coveo-sort-dropdown .coveo-dropdown',
  searchSortOptions: '.search-list-row__coveo-sort-dropdown .coveo-dropdown option, .resource-listing-row__coveo-sort-dropdown .coveo-dropdown option',
  searchCareType: '.dropdown-module:first-child .dropdown.find-a-community-map-view-row__dynamic-facet .coveo-checkbox',
  searchDistance: '.dropdown-module:last-child .dropdown.find-a-community-map-view-row__dynamic-facet .coveo-checkbox',
  searchLabel: '.search-list-row__badges-row .coveo-accessible-button, .resource-listing-row__badges-row .coveo-accessible-button',
  searchResultsContainer: '.resource-listing-row__coveo-result-list',
  searchPageContainer: '.search-list-row.CoveoSearchInterface, .find-a-community-map-view-row.CoveoSearchInterface, .resource-listing-row.CoveoSearchInterface',
  searchResultItem: '.coveo-result-frame',
  searchResultTitle: '.search-list-row__coveo-result-link, .resource-listing-row__coveo-result-link',
  navSearchTerm: '.search-masthead__coveo-search-bar .magic-box-input input',
  listingSearchTerm: '.resource-listing-row__coveo-main-section .resource-listing-row__facets-and-results-container .resource-listing-row__coveo-results-column .resource-listing-row__coveo-results-header .resource-listing-row__coveo-sort-and-search .resource-listing-row__coveo-search-bar input',
  communitySearchTerm: '.find-a-community-masthead .find-a-community-heading__search-bar .location-selector__container .location-selector__input .location-selector__coveo-search-omnibox .magic-box-input input',
  navSearchCount: '.search-list-row__coveo-main-section .search-list-row__facets-and-results-container .search-list-row__coveo-results-column .search-list-row__coveo-results-header .search-list-row__coveo-summary-section span:nth-child(3)',
  listingSearchCount: '.resource-listing-row__coveo-main-section .resource-listing-row__facets-and-results-container .resource-listing-row__coveo-results-column .resource-listing-row__coveo-results-header .resource-listing-row__coveo-summary-section span:nth-child(3)',
  communitySearchCount: '.find-a-community-map-view-row .find-a-community-map-view-row__coveo-main-section .find-a-community-map-view-row__facets-and-results-container .find-a-community-map-view-row__coveo-results-column .find-a-community-map-view-row__coveo-results-header .find-a-community-map-view-row__coveo-summary-section span:nth-child(3)',
  locationSearchButton: '.homepage-masthead .homepage-masthead__wrapper .homepage-masthead__overlay .homepage-masthead__location-selector-wrapper .location-selector__container > button',
  locationSearchCountrySelect: '.homepage-masthead .homepage-masthead__wrapper .homepage-masthead__overlay .homepage-masthead__location-selector-wrapper .location-selector__container .location-selector__country-select select',
  locationSearchCareTypeSelect: '.homepage-masthead .homepage-masthead__wrapper .homepage-masthead__overlay .homepage-masthead__location-selector-wrapper .location-selector__container .location-selector__care-type select',
  locationSearchContainer: '.homepage-masthead .homepage-masthead__wrapper .homepage-masthead__overlay .homepage-masthead__location',
  locationSearchTerm: '.homepage-masthead .homepage-masthead__wrapper .homepage-masthead__overlay .homepage-masthead__location-selector-wrapper .location-selector__container input',
  // Nav
  sideNavSection: '.hamburger-menu__child-menu',
  navActiveDrawer: '.primary-nav__item--expanded',
  navLinkSubTitle: '.primary-nav__sub-item-title a',
  navLink: '.primary-nav__link-item a',
  topNavSection: '.primary-nav__child-menu-item-inner',
  topNavSupSection: '.primary-nav__supporting-column-inner',
  topNavSupCommunitySection: '.communities-supporting-column',
  topNavSupLink: '.faqs-supporting-column__question, .primary-nav__supporting-column-cta',
  topNavSupCommunityLink: '.communities-supporting-column__community',
  topNavSupTitle: '.primary-nav__supporting-column-title',
  footerNavSection: '.footer__col',
  footerNavLinkTitle: '.footer__col-title a',
  footerNavLink: '.footer-links a',
  footerNavSocial: '.footer-social-links__item a',
  footerNavUtilLink: '.footer__utility-links a',
  // Homepage
  homepageContentButton: '.two-tabs-masthead-extension .two-tabs-masthead-extension__tabs button',
  // Care Questionare
  careQuestionareContainer: '.two-tabs-masthead-extension__panel .step-form',
  careQuestionareNext: '.step-form__next',
  careQuestionareSelected: '.field__checkbox:checked',
  careQuestionareSection: '.step-form__section-wrapper',
  careQuestionareTextarea: '.step-form__section-wrapper .field__textarea',
  // Forms
  form: 'form',
  contactUsForm: '.community-contact-us__form',
  contactUsFormZip: '#com-con-zip-code',
  contactUsFormTopic: '.community-contact-us__topics select',
  // Carousel
  carouselContainer: '.nearby-communities-row__inner',
  carouselLink: '.swiper-slide a',
  carouselLinkTitle: 'h1',
  carouselLinkCta: '.nearby-communities-row__link',
  // CTAs
  ctaCard: '.latest-news__featured, .latest-news__item a, .hightlights-row-accordion, .image-cards-row__item-inner',
  ctaCardLinkTitle: '.latest-news__item-heading, .latest-news__featured-heading, .hightlights-row__card-title, .image-cards-row__item-title',
  ctaCardLinkLabel: '.link__label',
  ctaLink: 'a',
  ctaButton: '.btn--primary:not(.btn--no-fill)',
  // QuickAccess
  quickAccessContainer: '.quick-access__inner',
  quickAccessHeading: '.quick-access__trigger[aria-selected="true"]',
  quickAccess: '.quick-access__card',
  // FAQs
  faqOutterContainer: '.faqs-container__navegation',
  faqContainer: '.faqs-container__item',
  faq: '.faqs-container__item-trigger',
  faqQuestion: '.faqs-container__item-content a',
  // Video
  videoContainer: '.gallery-row__preview__video__iframe',
  videoPlayButton: '.gallery-row__preview__play-video-btn',
  videoTitle: '.masthead-common-content__heading'
};

export const formatStr = str => str.trim().toLowerCase().replaceAll('\n', ' ')

export const trackEvent = data => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
};
